import { DirectiveOptions, VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';

import { getWindowLocation } from 'frontend/utils/location';

import { track as trackAnalytics } from 'frontend/utils/analytics';

export interface TrackingConfig {
  axId: string;
  axType?: 'link' | 'button';
  axAction?: string;
  axLabel?: string;
  axExtra?: { [key: string]: string | number };
}

let sendTracking: (event: Event) => void;

export const track: DirectiveOptions = {
  bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    if (binding.arg && (binding.arg === 'click' || binding.arg === 'change')) {
      sendTracking = (event: Event) => {
        if (el.dataset.active === 'true' || !binding.value || !binding.value.axId) {
          return;
        }
        let axId = binding.value.axId;
        if (
          binding.value.axId.indexOf('[[value]]') !== 0 &&
          event.target instanceof HTMLSelectElement
        ) {
          axId = axId.replace('[[value]]', event.target.value);
        }
        el.dataset.active = 'true';
        let path;
        let fullPath;
        if (vnode && vnode.context && vnode.context.$route) {
          path = vnode.context.$route.path;
          fullPath = vnode.context.$route.fullPath;
        } else {
          const windowLocation = getWindowLocation();
          path = windowLocation.pathname;
          fullPath = `${windowLocation.pathname}?${windowLocation.search}`;
        }

        const extraParams = binding.value.axExtra || {};

        const eventParams = {
          path,
          element_type: binding.value.axType || 'link',
          element_id: axId,
          full_path: fullPath,
          action: binding.value.axAction || 'click',
          ...extraParams,
        };

        if (!binding.modifiers.once || el.dataset.sent !== 'true') {
          trackAnalytics('ui', eventParams);
          el.dataset.sent = 'true';
        }
        el.dataset.active = 'false';
      };

      el.addEventListener(binding.arg, sendTracking);
    }
  },
  unbind(el: HTMLElement, binding: DirectiveBinding) {
    if (binding.arg && (binding.arg === 'click' || binding.arg === 'change')) {
      const arg: string = binding.arg;
      // Use setTimeout to prevent the the event listener from being removed before the event is
      // tracked. This can happen when the element is removed immediately after clicking.
      setTimeout(() => el.removeEventListener(arg, sendTracking), 1);
    }
  },
};

export const clickableHover: DirectiveOptions = {
  bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    const className = binding.value || 'hover';
    el.addEventListener('mouseenter', () => el.classList.add(className));
    el.addEventListener('mouseleave', () => el.classList.remove(className));
    el.addEventListener('click', () => el.classList.remove(className));
  },
};
